import { useResponsiveValue } from 'braid-design-system';
import React from 'react';

const UpsellIcon = () => {
  const responsiveValue = useResponsiveValue();
  return (
    <svg
      style={{ display: 'block' }}
      width={
        responsiveValue({
          mobile: '80px',
          tablet: '96px',
        }) as string
      }
      height={
        responsiveValue({
          mobile: '80px',
          tablet: '96px',
        }) as string
      }
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M117.516 66.8187C117.299 66.0283 116.392 65.4552 115.582 65.7206C114.433 66.097 113.153 66.1171 111.955 65.8361C113.364 64.1093 113.934 61.9599 112.798 59.6245C112.164 58.3212 110.89 57.3607 109.434 57.2275C107.906 57.0879 106.539 57.9966 105.742 59.251C104.396 61.3705 104.903 64.1941 106.43 66.0838C105.584 66.4509 104.683 66.6797 103.77 66.7565C103.396 47.4921 84.702 31.9697 61.6805 31.9697C57.238 31.9697 52.9582 32.5516 48.9377 33.6229C46.2083 29.7073 41.6788 27.1396 36.5439 27.1396V38.9631C28.9719 43.7037 23.3624 50.5321 20.9219 58.4339H15.4777C13.557 58.4339 12 59.9909 12 61.9116V72.7728C12 74.6935 13.557 76.2506 15.4777 76.2506H20.9219C23.1787 83.5575 28.1449 89.9471 34.8675 94.6163V107.671H47.8204L49.4199 101.187C53.3 102.177 57.415 102.715 61.6805 102.715C67.2267 102.715 72.5171 101.805 77.3663 100.168L79.217 107.671H92.17V91.7243C98.703 85.9609 102.94 78.3509 103.665 69.9203C105.441 69.8167 107.442 69.1873 109.167 68.1691C111.4 69.2507 114.114 69.5077 116.418 68.7528C117.225 68.4885 117.749 67.6656 117.516 66.8187ZM108.125 61.7269C108.205 61.1997 108.516 60.4725 109.047 60.3588C109.497 60.2623 109.878 60.7486 110.037 61.1064C110.286 61.67 110.281 62.3007 110.054 62.912C109.858 63.4405 109.501 63.9042 109.094 64.3089C108.404 63.59 107.982 62.6769 108.125 61.7269Z"
        fill="#F470BD"
      />
      <path
        d="M32.8098 58.5436C32.6886 59.9952 31.4134 61.0737 29.9618 60.9526C28.5102 60.8314 27.4316 59.5564 27.5527 58.1048C27.6739 56.6532 28.9489 55.5746 30.4005 55.6958C31.8521 55.817 32.9309 57.092 32.8098 58.5436Z"
        fill="#072462"
      />
      <path
        d="M72.6247 37.5527H53.6357V40.2034H72.6247V37.5527Z"
        fill="#0D3880"
      />
      <path
        d="M63.7786 38.6113C70.4839 38.6113 75.9197 33.1756 75.9197 26.4702C75.9197 19.7649 70.4839 14.3291 63.7786 14.3291C57.0732 14.3291 51.6375 19.7649 51.6375 26.4702C51.6375 33.1756 57.0732 38.6113 63.7786 38.6113Z"
        fill="#FDC221"
      />
      <path
        d="M63.7786 34.693C68.3201 34.693 72.0016 31.0115 72.0016 26.47C72.0016 21.9286 68.3201 18.2471 63.7786 18.2471C59.2372 18.2471 55.5557 21.9286 55.5557 26.47C55.5557 31.0115 59.2372 34.693 63.7786 34.693Z"
        fill="#DFA414"
      />
      <path
        d="M62.9591 27.0193H64.5982C65.03 27.0658 65.3713 27.4071 65.4178 27.8389C65.3655 28.268 65.0274 28.6061 64.5982 28.6584H62.1396C61.687 28.6584 61.32 29.0254 61.32 29.478C61.32 29.9305 61.687 30.2975 62.1396 30.2975H62.9591V31.1171C62.9591 31.5696 63.3261 31.9366 63.7787 31.9366C64.2312 31.9366 64.5982 31.5696 64.5982 31.1171V30.2975C65.4767 30.2975 66.2882 29.8288 66.7276 29.0682C67.1666 28.3075 67.1666 27.3702 66.7276 26.6095C66.2882 25.8489 65.4767 25.3802 64.5982 25.3802H62.9591C62.5065 25.3802 62.1396 25.0132 62.1396 24.5606C62.1396 24.1081 62.5065 23.7411 62.9591 23.7411H65.4178C65.8703 23.7411 66.2373 23.3741 66.2373 22.9215C66.2373 22.469 65.8703 22.102 65.4178 22.102H64.5982V21.2824C64.5982 20.8299 64.2312 20.4629 63.7787 20.4629C63.3261 20.4629 62.9591 20.8299 62.9591 21.2824V22.102C62.0807 22.102 61.2692 22.5707 60.8298 23.3313C60.3907 24.092 60.3907 25.0293 60.8298 25.79C61.2692 26.5506 62.0807 27.0193 62.9591 27.0193Z"
        fill="white"
      />
      <path
        d="M33.1659 74.968C32.2099 74.968 31.2601 74.7458 30.3803 74.3059C29.8861 74.0588 29.6859 73.4582 29.933 72.9641C30.1801 72.47 30.7797 72.2693 31.2748 72.5168C32.288 73.0241 33.4393 73.1067 34.5131 72.7473C35.5883 72.3889 36.4594 71.6335 36.9662 70.6199C37.2133 70.1262 37.8134 69.9245 38.308 70.1726C38.8021 70.4197 39.0023 71.0203 38.7553 71.5144C38.0092 73.0056 36.7274 74.1174 35.1459 74.6448C34.4974 74.8606 33.83 74.968 33.1659 74.968Z"
        fill="#E60278"
      />
    </svg>
  );
};

export default UpsellIcon;
